import { Vote } from 'lucide-react';

function BrandMark() {
  return (
    <div className="inline-flex items-center gap-3" aria-label="Votum">
      <span className="grid size-10 place-items-center rounded-xl bg-primary-400 text-slate-950 shadow-glow">
        <Vote size={21} strokeWidth={2.4} aria-hidden="true" />
      </span>
      <span className="text-lg font-semibold tracking-[0.22em] text-white">
        VOTUM
      </span>
    </div>
  );
}

export default BrandMark;
